/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceInvoiceIdRequest
 */
export interface InvoiceInvoiceIdRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceInvoiceIdRequest
     */
    invoiceId: string;
    notificationTypes: string[];
}

/**
 * Check if a given object implements the InvoiceInvoiceIdRequest interface.
 */
export function instanceOfInvoiceInvoiceIdRequest(value: object): value is InvoiceInvoiceIdRequest {
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    return true;
}

export function InvoiceInvoiceIdRequestFromJSON(json: any): InvoiceInvoiceIdRequest {
    return InvoiceInvoiceIdRequestFromJSONTyped(json, false);
}

export function InvoiceInvoiceIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceInvoiceIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': json['invoiceId'],
        'notificationTypes': json['notificationTypes'],
    };
}

export function InvoiceInvoiceIdRequestToJSON(json: any): InvoiceInvoiceIdRequest {
    return InvoiceInvoiceIdRequestToJSONTyped(json, false);
}

export function InvoiceInvoiceIdRequestToJSONTyped(value?: InvoiceInvoiceIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': value['invoiceId'],
        'notificationTypes': value['notificationTypes'],
    };
}

